var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        position: "fixed",
        width: "0",
        height: "0",
        overflow: "hidden",
        top: "-99px",
      },
    },
    [
      _c(
        "svg",
        {
          attrs: {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
          },
        },
        [
          _c("defs", [
            _c(
              "symbol",
              {
                attrs: {
                  width: "22",
                  height: "12",
                  fill: "none",
                  id: "arrow-down",
                  viewBox: "0 0 22 12",
                },
              },
              [
                _c("title", [_vm._v("Arrow down")]),
                _c("path", {
                  attrs: { d: "M0.5 1L11 11L21.5 1", stroke: "currentColor" },
                }),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }